// extracted by mini-css-extract-plugin
module.exports = {"badge":"_7a3fb80146--badge--gJbp_","description":"_7a3fb80146--description--kHoLE"};